export default __webpack_public_path__ + "static/media/Coralogix.cec9ea9c.svg";